import { render, staticRenderFns } from "./Cart2.vue?vue&type=template&id=662e3c6f&scoped=true"
import script from "./Cart2.vue?vue&type=script&lang=js"
export * from "./Cart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e3c6f",
  null
  
)

export default component.exports